import { ArrowLeftOutlined } from "@ant-design/icons";
import { Select, Table, Tag } from "antd";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Card, CardBody, CardTitle, Col, Row } from "reactstrap";
import { fetchBidComparison } from "../../../../api/bid.api";
import "./bid.style.css";

function BidComparison() {
  const { id } = useParams();
  const history = useNavigate();
  const [loading, setLoading] = useState(false);
  const [lowestBid, setLowestBid] = useState("None");
  const [vendorBids, setVendorBids] = useState([]);
  const [base_vendor_prices, setBaseVendorPrices] = useState(null);
  const [vendors, setVendors] = useState([]);
  const [selected_vendor, setSelectedVendor] = useState([]);
  const [formattedVendorBids, setFormattedVendorBids] = useState([]);
  const [columns, setColumns] = useState([
    {
      title: "S.no",
      key: "s_no",
      dataIndex: "s_no",
      width: 100,
    },
    {
      title: "Item Name",
      key: "item_name",
      dataIndex: "item_name",
      width: 650,
    },
  ]);
  const navigate = useNavigate();
  console.log("bid id", id);
  const goBack = () => {
    navigate(-1);
  };
  useEffect(() => {
    getLowestBid();
  }, [vendorBids]);
  useEffect(() => {
    getBidComparison();
  }, []);

  useEffect(() => {
    console.log("additional COl", columns, formattedVendorBids);

    setFormattedVendorBids([...formattedVendorBids]);
    let additionalColumns = [];

    vendorBids?.map((bidSubmission, vendorIndex) => {
      additionalColumns.push({
        title: bidSubmission?.vendor_name,
        key: bidSubmission?.vendor_id?.toString(),
        // dataIndex: bidSubmission?.vendor_id?.toString(),
        render: (data) => (
          <div>{getString(data[bidSubmission?.vendor_id], data?.item_id)}</div>
        ),
      });
    });
    setColumns([
      {
        title: "S no",
        key: "action",
        render: (value, record, index) => index + 1,
        width: 80,
      },
      {
        title: "Item Name",
        key: "item_name",
        dataIndex: "item_name",
        width: 650,
      },
      ...additionalColumns,
    ]);
  }, [base_vendor_prices]);

  useEffect(() => {
    setTableColumns();
  }, [vendorBids]);

  useEffect(() => {}, [columns]);

  const getBidComparison = () => {
    fetchBidComparison({ params: { bid_id: id } }).then((resp) => {
      console.log("Bid details", resp);
      setVendorBids(resp?.vendor);
    });
  };

  const getString = (price, item_id) => {
    console.log("getString", base_vendor_prices, price, item_id);
    if (base_vendor_prices) {
      let color = "#6CFFAF";
      let diff =
        (Math.abs(price - base_vendor_prices[item_id]) /
          base_vendor_prices[item_id]) *
        100;
      if (diff > 20) {
        color = "#FF8B6F";
      } else if (diff > 10) {
        color = "#FFD732";
      } else if (diff > 5) {
        color = "#FFFFBE";
      }

      return (
        <div
          style={{
            background: color,
          }}
        >
          {price}
        </div>
      );
    }

    return (
      <div>
        {price}---nothing--{item_id}
      </div>
    );
  };

  const setTableColumns = async () => {
    let additionalColumns = [];
    let formatVendorBids = [];
    let itemRows = [];
    let vendors_from_bids = [];
    let base_prices = {};

    await Promise.all(
      vendorBids[0]?.vendor_bid?.map((item) => {
        itemRows.push({
          item_id: item?.item_id,
          item_name: item?.item_name,
          quantity: item?.quantity,
        });
      })
    );
    await Promise.all(
      vendorBids?.map((bidSubmission, vendorIndex) => {
        vendors_from_bids.push({
          value: bidSubmission?.vendor_name,
          label: bidSubmission?.vendor_name,
        });

        additionalColumns.push({
          title: bidSubmission?.vendor_name,
          key: bidSubmission?.vendor_id?.toString(),
          // dataIndex: bidSubmission?.vendor_id?.toString(),
          render: (data) => (
            <>{getString(data[bidSubmission?.vendor_id], data?.item_id)}</>
          ),
        });
        bidSubmission?.vendor_bid?.map((item) => {
          const index = itemRows.findIndex(
            (obj) => obj.item_id == item.item_id
          );
          itemRows[index][bidSubmission?.vendor_id] = item?.bid_unit_price;
        });
      })

      // vendorBids?.map((bidSubmission, vendorIndex) => {
      //   formatVendorBids.push({
      //     vendor_name: bidSubmission?.vendor_name,
      //     total_bid_price: bidSubmission?.total_bid_price,
      //     delivery_date: bidSubmission?.delivery_date,
      //   });
      //   bidSubmission?.vendor_bid.map((item) => {
      //     const index = additionalColumns?.findIndex(
      //       (col) => col.key == item.item_id
      //     );
      //     if (index > -1) {

      //     } else {
      //       additionalColumns.push({
      //         title: item?.item_name,
      //         key: item?.id?.toString(),
      //         dataIndex: item?.id?.toString(),
      //       });
      //     }
      //     formatVendorBids[vendorIndex][item?.id] = item?.bid_unit_price;
      //   });
      // })
    );
    itemRows.push({
      item_id: "Total",
      item_name: "Total",
      quantity: "",
    });

    await Promise.all(
      vendorBids?.map((bidSubmission, vendorIndex) => {
        bidSubmission?.vendor_bid?.map((item) => {
          const index = itemRows.findIndex((obj) => obj.item_id == "Total");
          itemRows[index][bidSubmission?.vendor_id] =
            bidSubmission?.total_bid_price;
        });
      })
    );
    setFormattedVendorBids(itemRows);
    console.log("additional COl", additionalColumns, formatVendorBids);
    setColumns([...columns, ...additionalColumns]);
    setVendors(vendors_from_bids);
    if (vendors_from_bids?.length > 0) {
      setSelectedVendor(vendors_from_bids[0]?.value);
      await Promise.all(
        vendorBids[0]?.vendor_bid?.map((item) => {
          base_prices[item.item_id] = item?.bid_unit_price;
        })
      );
      base_prices["Total"] = vendorBids[0]?.total_bid_price;
      setBaseVendorPrices(base_prices);
      console.log(
        "base_prices",
        base_prices,
        itemRows,
        additionalColumns,
        vendorBids
      );
    }
  };

  const getLowestBid = async () => {
    let min = 1000000000;
    vendorBids?.map((bid) => {
      if (min > bid?.total_bid_price && bid?.total_bid_price > 0) {
        min = bid?.total_bid_price;
      }
      if (min != 1000000000) {
        setLowestBid(min);
      }
    });
  };

  const getHighestBid = () => {
    let max = Math.max(...vendorBids.map((item) => item.total_bid_price));

    if (max === 0 || !max) {
      return "None";
    }
    return max?.toFixed(2);
  };

  useEffect(() => {
    let vendor = vendorBids?.find(
      (vendor) => vendor.vendor_name == selected_vendor
    );
    let base_prices = { ...base_vendor_prices };

    vendor?.vendor_bid?.map((item) => {
      base_prices[item.item_id] = item?.bid_unit_price;
    });
    base_prices["Total"] = vendor?.total_bid_price;
    setBaseVendorPrices(base_prices);
    console.log("base_prices", base_prices, vendor, formattedVendorBids);
  }, [selected_vendor]);

  return (
    <React.Fragment>
      <Card
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "start",
          flexDirection: "row",
          padding: "18px 15px",
          marginBottom: "15px",
        }}
      >
        <ArrowLeftOutlined style={{ fontSize: "25px" }} onClick={goBack} />
        <div
          style={{
            marginBottom: "1px",
            marginLeft: "10px",
            fontSize: "20px",
            fontWeight: "600",
          }}
        >
          Bid Comparison
        </div>
        <CardTitle style={{ marginBottom: "0px", marginLeft: "17px" }}>
          {" "}
          Compare the submissions of various vendors on the bid that you raised
        </CardTitle>
      </Card>

      <Row>
        {/* <Col>
          <Card>
            <Tag
              color="purple"
              style={{
                cursor: "pointer",
                alignItems: "center",
                padding: "10px 6px",
                display: "flex",
                flexDirection: "column",
                marginRight: "0px",
              }}
            >
              <h2 style={{ color: "#a26fe2" }}>
                {formattedVendorBids?.length}
              </h2>
              <h6 style={{ color: "#a26fe2" }}>Total number of vendors</h6>
            </Tag>
          </Card>
        </Col> */}
        <Col>
          <Card>
            <Tag
              color="blue"
              style={{
                cursor: "pointer",
                alignItems: "center",
                padding: "10px 6px",
                display: "flex",
                flexDirection: "column",
                marginRight: "0px",
              }}
            >
              <h2 style={{ color: "#2b97fe" }}>{vendorBids?.length}</h2>
              <h6 style={{ color: "#2b97fe" }}>Total number of Submissions</h6>
            </Tag>
          </Card>
        </Col>
        <Col>
          <Card>
            <Tag
              color="green"
              style={{
                cursor: "pointer",
                alignItems: "center",
                padding: "10px 6px",
                display: "flex",
                flexDirection: "column",
                marginRight: "0px",
              }}
            >
              <h2 style={{ color: "#88d662" }}>
                {"₹"}
                {lowestBid}
              </h2>
              <h6 style={{ color: "#88d662" }}>Lowest Bid</h6>
            </Tag>
          </Card>
        </Col>
        <Col>
          <Card>
            <Tag
              color="red"
              style={{
                cursor: "pointer",
                alignItems: "center",
                padding: "10px 6px",
                display: "flex",
                flexDirection: "column",
                marginRight: "0px",
              }}
            >
              <h2 style={{ color: "#f7545b" }}>
                {"₹"}
                {getHighestBid()}
              </h2>
              <h6 style={{ color: "#f7545b" }}>Highest Bid</h6>
            </Tag>
          </Card>
        </Col>
      </Row>

      <Card>
        <CardBody>
          <Row className="d-flex justify-content-end">
            <Col>
              <div>Select vendor</div>
              <Select
                style={{ width: 200 }}
                value={selected_vendor}
                onChange={(e) => {
                  setSelectedVendor(e);
                }}
                options={vendors}
              />
            </Col>
            {/* <Col>
              <div>Select metric</div>
              <Select
                onChange={() => {}}
                options={[
                  {
                    value: "average",
                    label: "Average",
                  },
                  {
                    value: "average",
                    label: "Average",
                  },
                ]}
              />
            </Col> */}
          </Row>
        </CardBody>
      </Card>
      <Card>
        <CardBody>
          <div className="">
            <Table
              loading={loading}
              rowClassName={(record, index) =>
                index === formattedVendorBids?.length - 1
                  ? "table-row-dark"
                  : ""
              }
              rowKey={"table"}
              dataSource={formattedVendorBids}
              columns={columns}
              scroll={{ x: "max-content" }}
              pagination={false}
            />
          </div>
        </CardBody>
      </Card>
    </React.Fragment>
  );
}

export default BidComparison;
